import React, { useState, forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import { Formik, Form, useFormikContext } from 'formik'
import Card from 'components/Card'
import { s } from '@vega/styled/v2'
import { SubEntityActionButton, CollapseButton, Chip } from 'components/common'
import { formatCurrency, formatStringToNumber } from 'utils/formatters'
import { updateAsset, removeAsset } from 'modules/application'
import { AssetFields } from './AssetFields'
import * as Yup from 'yup'

// TODO: move schemas into one place
export const ownershipSchema = Yup.object({
  percentage: Yup.number()
    .min(0, 'The minimum ownership percentage is 0')
    .max(100, 'The maximum ownership percentage is 100')
    .required('Ownership percentage is required'),
  owner: Yup.string().required('Owner is required'), // TODO: adding in mongoDB validate function
})

export const assetSchema = Yup.object({
  assetType: Yup.string().required('Asset type is required'),
  ownerships: Yup.array()
    .of(ownershipSchema)
    .test(
      'ownership-sum-100',
      'Total ownership percentage must equal 100%',
      // eslint-disable-next-line prefer-arrow-callback
      function (ownerships) {
        const sum = ownerships.reduce((acc, ownership) => acc + ownership.percentage, 0)
        return sum === 100
      }
    ),
  description: Yup.string().required(),
  value: Yup.number().min(0, 'Value must be positive').required(),
})

// TODO: I wonder if this could take a function and be generic?
const AutoDispatcher = ({ index, applicationId }) => {
  const dispatch = useDispatch()

  const { values } = useFormikContext()
  React.useEffect(() => {
    // TODO: fix the bloody NumberField!
    const formattedValues = {
      ...values,
      value: formatStringToNumber(`$${values.value}`),
    }

    dispatch(
      updateAsset({ assetIndex: index, asset: formattedValues, id: applicationId })
    )
  }, [dispatch, index, values, applicationId])
  return null
}

const AssetCard = forwardRef(({ asset, index, applicationId, applicants }, ref) => {
  const dispatch = useDispatch()
  const [collapsed, setCollapsed] = useState(false)
  const toggleCollapased = () => setCollapsed(!collapsed)

  // TODO: Add a chip for asset type
  if (collapsed) {
    return (
      <Card style={s('mb-12')}>
        <div style={s('flex justify-end')}>
          <SubEntityActionButton
            style={s('bg-accent-red text-white', { width: 'auto' })}
            onClick={() => {
              dispatch(removeAsset({ assetIndex: index, id: applicationId }))
            }}
          >
            Remove asset
          </SubEntityActionButton>
        </div>
        <h1 style={s('m-0 p-0 text-2xl', { flexGrow: 1 })}>
          {asset.description || '-'}
        </h1>
        <div style={s('flex')}>
          <Chip>{asset.assetType}</Chip>
        </div>

        <p>Value: {asset.value ? formatCurrency(asset.value) : '-'}</p>

        <CollapseButton onClick={toggleCollapased}>+ Expand</CollapseButton>
      </Card>
    )
  }

  return (
    <Card style={s('mb-12')} ref={ref} id={asset._id}>
      <Formik initialValues={asset} enableReinitialize validationSchema={assetSchema}>
        {({ values, handleChange, handleBlur, setFieldValue, errors }) => (
          <Form>
            <div style={s('flex justify-end')}>
              <SubEntityActionButton
                style={s('bg-accent-red text-white', { width: 'auto' })}
                onClick={() => {
                  dispatch(removeAsset({ assetIndex: index, id: applicationId }))
                }}
              >
                Remove asset
              </SubEntityActionButton>
            </div>

            <AutoDispatcher index={index} applicationId={applicationId} />

            <h1 style={s('m-0 p-0 text-2xl', { flexGrow: 1 })}>
              {asset.description || '-'}
            </h1>

            <AssetFields
              handleChange={handleChange}
              handleBlur={handleBlur}
              values={values}
              applicants={applicants}
              setFieldValue={setFieldValue}
              errors={errors}
            />
            <CollapseButton onClick={toggleCollapased}>- Collapse</CollapseButton>
          </Form>
        )}
      </Formik>
    </Card>
  )
})

AssetCard.displayName = 'AssetCard'

export default AssetCard
